// extracted by mini-css-extract-plugin
export default {"divParent":"style_divParent__WRg-3","textCategory":"style_textCategory__iGlit","divEnable":"style_divEnable__7kr1P"};